import React, { useState, useEffect } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";

import Loading from "./components/Loading";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./views/Home";
import Profile from "./views/Profile";
import OrgAdmin from "./views/OrgAdmin";
import SuperAdmin from "./views/SuperAdmin";
import { useAuth0 } from "@auth0/auth0-react";
import history from "./utils/history";

// styles
import "./App.css";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";
initFontAwesome();

const App = () => {
  const { isAuthenticated, user, loginWithRedirect, isLoading, error } = useAuth0();
    const apiOrigin = process.env.REACT_APP_API
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  if (urlParams.get('invitation')) {
    loginWithRedirect({invitation: urlParams.get('invitation')})
  }


  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (isLoading) {
    return <Loading />;
  }


  return (
    <Router history={history}>
      <div id="app" className="d-flex flex-column h-100">
        <NavBar />
        <Container className="flex-grow-1 mt-5">
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/profile" component={Profile} />
            <Route path="/admin" component={OrgAdmin} />
            <Route path="/super-admin" component={SuperAdmin} />
          </Switch>
        </Container>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
